import * as S from "./JoinProcessBar.style";
import { useEffect, useState } from "react";

interface JoinProcessBarProps {
  stepNow: number;
  stepTotal: number;
}

export const JoinProcessBar = ({ stepNow, stepTotal }: JoinProcessBarProps) => {
  const [step, setStep] = useState<number>();

  useEffect(() => {
    const stepLength = (stepNow / stepTotal) * 100;
    setStep(stepLength);
  }, []);

  return (
    <S.JoinProcessBar>
      <S.ProcessNumberBox>
        {stepNow} / {stepTotal}
      </S.ProcessNumberBox>
      <S.ProcessGaugeBar step={step}>
        <span />
      </S.ProcessGaugeBar>
    </S.JoinProcessBar>
  );
};
